/**Imports from npm */
import React ,{ useEffect, useContext, useState, Fragment} from 'react';
import { Form, Input, Button, Select,DatePicker, Card, Row, Col,Typography, Tooltip,Modal} from 'antd';

import axios from 'axios'
import { AuthContext } from '../context/Auth';
import {useForm, Controller, FormContext} from 'react-hook-form';
import GoogleApi from '../components/GoogleApi';
import MapGoogle from '../components/Map';
import { CircularProgress } from '@material-ui/core';
import './css/styles.css';
import moment from 'moment';
import { API_URL } from '../context/constants';

import {InfoCircleFilled} from '@ant-design/icons'
import Text from 'antd/lib/typography/Text';

// import locale from 'antd/es/locale/es_ES'

const {Title}=Typography

const {Option}=Select
/**Beginning of the component */
const UserProfile = () => {

    const methods=useForm();
    /**Context del usuario */
     const {currentUser,token}=useContext(AuthContext);
     /**Data del servidor */
      const [data,setData]=useState({});
      const [loading,setLoading]=useState(true);
      /**Coordenadas por default del mapa */
      const [coordinates, setCoordinates] = useState({
        lat:40.416690,lng:-3.700340
      });
      /**States para manejar el formulario */
      const [tipoTurno,setTipoTurno]=useState('');
      const [errorTipoTurno,setErrorTipoTurno]=useState(false);

      const [tipoRotacion,setTipoRotacion]=useState('');
      const [errorRotacion,setErrorRotacion]=useState(false)

      const [turno,setTurno]=useState('');
      const [errorTurno,setErrorTurno]=useState(false)

      const [semanaReferencia,setSemanaReferencia]=useState();
      const [errorSemanaReferencia,setErrorSemanaReferencia]=useState(false);

      // const [dosSemanas,setDosSemanas]=useState();
      // const [errorDosSemanas,setErrorDosSemanas]=useState();

      // const [libGoogle,setLibGoogle]=useState(false)


      const [address, setAddress] = useState("");
      const [errorAddress,setErrorAddress]=useState(false);
      const success = () => {
        // message.success('Tu informacion ha sido actualizada');
        Modal.success({
          content:'Su información se ha actualizado correctamente.'
        })
      };
      const error = () => {
        // message.error('No se ha podido actualizar tu información, intentelo de nuevo');
        Modal.error({
          content:'No se ha podido actualizar su información. Inténtelo de nuevo.'
        })
      };
     
    useEffect(() => {    
      
      if(!token)
      return
      
      const getUserData=async()=>{
        
        setLoading(true)
        const r=await axios.get(`${API_URL}/profile/${currentUser.uid}`,{
          headers:{
            token
          }
        });
        setAddress(r.data.direccion);
        setTipoTurno(r.data.tipoTurno);
        setTipoRotacion(r.data.tipoRotacion)
        setTurno(r.data.turno);
        if(r.data.semanaReferencia===""||r.data.semanaReferencia===" "){
          
        }else{
          setSemanaReferencia(moment(r.data.semanaReferencia,'DD-MM-YYYY'))
        }
        // else if(r.data.semanaReferencia.includes('/')){
        //   const semanas=r.data.semanaReferencia.split('/');
     
        //   setDosSemanas([moment(semanas[0],'DD-MM-YYYY'),moment(semanas[1],'DD-MM-YYYY')])
        // }else{
        //   setSemanaReferencia(moment(r.data.semanaReferencia,'DD-MM-YYYY'))
        // }
        setData(r.data)
        setLoading(false)
      }
      getUserData();
      
      // eslint-disable-next-line
    }, [token])
    
    

    
    // console.log(data.semanaReferencia)
    
    const onSubmit=async(data)=>{
      let errorVal=false;
      if(tipoTurno===''){
        setErrorTipoTurno(true);
        errorVal=true;
      }
      if(tipoRotacion===''&&tipoTurno==="Rotativo"){
        setErrorRotacion(true);
        errorVal=true;
      }
      if(turno===''){
        setErrorTurno(true);
        errorVal=true;
      }
      if(tipoTurno!=="Fijo"&&!semanaReferencia){
        setErrorSemanaReferencia(true);
        errorVal=true;
      }
      if(address===""){
        setErrorAddress(true);
        errorVal=true;
      }


      if(errorVal){
        return;
      }
      else{
        setErrorAddress(false)
        if(tipoTurno==="Fijo"){
          setTipoRotacion('');
          setSemanaReferencia('');
          data.semanaReferencia=''
          data.tipoRotacion='';
        }else{
          data.tipoRotacion=tipoRotacion;
          data.semanaReferencia=semanaReferencia.format('DD-MM-YYYY');
        }
        // if(tipoTurno==="Fijo"||tipoRotacion==="Semanal"){
        //    data.semanaReferencia=
        // }else{
        //   data.semanaReferencia=dosSemanas[0].format('DD-MM-YYYY')+'/'+dosSemanas[1].format('DD-MM-YYYY');
        // }
        data.direccion=address;
        data.tipoTurno=tipoTurno;
        data.turno=turno;
        try{
          await axios.patch(`${API_URL}/profile/usuario/${currentUser.uid}`,data,{
              headers:{
                token
              }
            });
            success();
            setErrorAddress(false)


        }catch(e){
          error();
        }

        
      }
  
      
    }
    function hanldeTipoTurno(e){
      setTipoTurno(e);
      if(e==='Fijo'){
        setSemanaReferencia();
      }
      setTipoRotacion('');
      setTurno('');
    }
    return ( 
      !token||loading?<CircularProgress/>
    :  
        <Fragment >
          
          <Title className="title"  style={{color: '#2B7BBC',fontWeight:200}} >
            Completa tu perfil
          </Title>
          <FormContext {...methods}>
          
          <Row gutter={30}>
          
            <Col span={10} xs={24} md={12} lg={12}>
            
            
                    <Form
                  layout='horizontal'
                  size='medium'
                  style={{height:'50%'}}
                  // onSubmitCapture={}
                 
                >
                  
                  <Form.Item label="Nombre" style={{marginRight:20}}>
                  <Controller rules={{required:true}}    as={Input}  name="nombre"  defaultValue={`${data.nombre}`} control={methods.control} />
                  {methods.errors.nombre&&<Text type='danger'>*El campo nombre es obligatorio</Text>}
                  
                  </Form.Item>
                  <Form.Item label="Correo">
                    <Controller disabled={true} as={Input} name="correo" defaultValue={`${data.correo}`} control={methods.control} />
                  </Form.Item>
                  <Form.Item label={<span>
                      Número de Empleado&nbsp;
                      <Tooltip title="Número identificativo y unívoco que le relaciona con su empresa. Debería ser el mismo número de empleado que usted tiene en su empresa.">
                        <InfoCircleFilled />
                      </Tooltip>
                    </span>} >
                  
                  <Controller disabled={true} as={Input} name="numEmpleado"defaultValue={`${data.numEmpleado}`}  control={methods.control} />
                  </Form.Item>
                  <Form.Item label="Teléfono">
                    <Controller  rules={{required:true}}  as={<Input/>} name="telefono"  defaultValue={`${data.telefono}`} control={methods.control} />
                  {methods.errors.telefono&&<Text type='danger'>*El campo teléfono es obligatorio</Text>}
                  </Form.Item>
                  <Form.Item label="Empresa">
                    <Controller rules={{required:true}} as={
                      <Input/>

                    } name="empresa"  defaultValue={`${data.empresa}`} control={methods.control} />
                  {methods.errors.empresa&&<Text type='danger'>*El campo Empresa es obligatorio</Text>}
                  </Form.Item>
                  <Form.Item label={
                    <span>
                      Destino&nbsp;
                      <Tooltip title="Seleccione la fábrica o empresa de destino.">
                        <InfoCircleFilled />
                      </Tooltip>
                    </span>
                   }>
                  
                    <Controller as={
                      <Select>
                      <Select.Option value='ACTEMIUM ASAS'>ACTEMIUM ASAS</Select.Option>
                      <Select.Option value='IMAN'>IMAN</Select.Option>
                      <Select.Option value='ILUNION'>ILUNION</Select.Option>
                      <Select.Option value='FAURECIA'>FAURECIA</Select.Option>
                      <Select.Option value='YANFENG'>YANFENG</Select.Option>
                      <Select.Option value='MLV'>MLV</Select.Option>
                      <Select.Option value='ASEPEYO'>ASEPEYO</Select.Option>
                      <Select.Option value='VEDAT MEDITERRANEO'>VEDAT MEDITERRANEO</Select.Option>
                      <Select.Option value='MECANIZADOS'>MECANIZADOS</Select.Option>
                      <Select.Option value='EINES'>EINES</Select.Option>
                      <Select.Option value='LEAR'>LEAR</Select.Option>
                      <Select.Option value='SODECIA'>SODECIA</Select.Option>
                      <Select.Option value='BENTELER'>BENTELER</Select.Option>
                      <Select.Option value='ITERA'>ITERA</Select.Option>
                      <Select.Option value='ISE LOGISTIC'>ISE LOGISTIC</Select.Option>
                      <Select.Option value='ATERSA'>ATERSA</Select.Option>
                      <Select.Option value='ERCROS'>ERCROS</Select.Option>
                      <Select.Option value='JEFRA'>JEFRA</Select.Option>
                      <Select.Option value='AVANZA'>AVANZA</Select.Option>
                    </Select>

                    } name="destino" rules={{required:true}} defaultValue={`${data.destino}`} control={methods.control} />
                  {methods.errors.destino&&<Text type='danger'>*El campo Destino es obligatorio</Text>}
                  </Form.Item>
                  <Form.Item label={
                    <span>
                    Polígono Industrial&nbsp;
                    <Tooltip title="Polígono industrial en el que se ubica la empresa o fábrica destino.">
                      <InfoCircleFilled />
                    </Tooltip>
                  </span>
                  }>
                  <Controller  
                  name="polIndustrial" 
                  control={methods.control}
                  defaultValue={data.polIndustrial}
                  rules={{required:true}}
                  as={
                    <Select>
                      <Select.Option value="POLÍGONO INDUSTRIAL JUAN CARLOS I - Almussafes, Valencia" >POLÍGONO INDUSTRIAL JUAN CARLOS I - Almussafes, Valencia</Select.Option>
                
                    </Select>
                  } 
                  />
                  {methods.errors.polIndustrial&&<Text type='danger'>*El campo Polígono Industrial es obligatorio</Text>}
                  
                  </Form.Item>
                  <Form.Item label={
                    <span>
                    Tipo de Turno&nbsp;
                    <Tooltip title="Seleccionar entre tipo de turno FIJO o ROTATIVO (alterna el turno semanalmente o quincenalmente)">
                      <InfoCircleFilled />
                    </Tooltip>
                  </span>
                  }>
                  <Select value={tipoTurno} defaultValue={tipoTurno} onChange={hanldeTipoTurno} onBlur={()=>tipoTurno===''?setErrorTipoTurno(true):setErrorTipoTurno(false)} >
                    <Option value="Fijo" >Fijo</Option>
                    <Option value="Rotativo" >Rotativo</Option>
                  </Select>
                  {errorTipoTurno&&<Text type='danger'>*El campo Tipo turno es obligatorio</Text>}
               
                  </Form.Item>
                  <Form.Item label={
                    <span>
                    Tipo de Rotación&nbsp;
                    <Tooltip title="SEMANAL implica que cada semana cambia de turno. QUINCENAL implica que cada 2 semanas cambia de turno.">
                      <InfoCircleFilled />
                    </Tooltip>
                  </span>
                  }>
                    <Select value={tipoRotacion} defaultValue={tipoRotacion}  disabled={tipoTurno==="Fijo"?true:false} onChange={(e)=>setTipoRotacion(e)} onBlur={()=>(tipoRotacion===''&&tipoTurno==="Rotativo")?setErrorRotacion(true):setErrorRotacion(false)} >
                      <Option value="Semanal" >Semanal</Option>
                      <Option value="Quincenal" >Quincenal</Option>
                    </Select>
                    {(errorRotacion&&tipoTurno==="Rotativo")&&<Text type='danger'>*El campo Tipo Rotación es obligatorio</Text>}
               
                 </Form.Item>
                 
                  
                  <Form.Item label={
                    <span>
                    Turno&nbsp;
                    <Tooltip title=" Seleccione su turno. Mañana (6h-14h), Tarde (14h-22h), Noche (22h-6h), Central (8:30h-17h)">
                      <InfoCircleFilled />
                    </Tooltip>
                  </span>
                  }>
                    <Select value={turno} defaultValue={turno}  onChange={(e)=>setTurno(e)} onBlur={()=>(turno==="")?setErrorTurno(true):setErrorTurno(false)} >
                      {tipoTurno==="Fijo"?(
                        <Fragment>
                          <Option value="Central" >Central</Option>
                          <Option value="Mañana" >Mañana</Option>
                          <Option value="Tarde" >Tarde</Option>
                          <Option value="Noche" >Noche</Option>
                        </Fragment>
                      ):(
                        <Fragment>
                          <Option value="Mañana-Tarde" >Mañana-Tarde</Option>
                          <Option value="Mañana-Tarde-Noche" >Mañana-Tarde-Noche</Option>
                        </Fragment>
                      )}
                    </Select>
                    {errorTurno&&<Text type='danger'>*El campo Turno es obligatorio</Text>}
                  </Form.Item>
                  {tipoTurno==="Fijo"?<></>:
                    <Form.Item label={
                      <span>
                      Semana de Referencia&nbsp;
                      <Tooltip title="Seleccione un día de la próxima semana que empieza su turno de MAÑANAS.">
                        <InfoCircleFilled />
                      </Tooltip>
                    </span>
                    }>

                    
                    <div style={{display:'flex',flexDirection:'column'}}>
                      <DatePicker
                      onBlur={()=>(!semanaReferencia)?setErrorSemanaReferencia(true):setErrorSemanaReferencia(false)} 
                       
                      defaultValue={semanaReferencia} 
                      value={semanaReferencia} 
                      onChange={e=>setSemanaReferencia(e)} 
                      format={'D-MM-YYYY'}
                      picker='week'
                      showToday={false}
                       />
                    {errorSemanaReferencia&&<Text type='danger'>*El campo Semana de Referencia es obligatorio</Text>}
                    </div>
                 
                    </Form.Item>
                  }
                
                    
              

              </Form> 

              </Col>
              <Col span={10}  xs={24} md={12} lg={12}>
              <Card title={<span>
                    Dirección&nbsp;
                    <Tooltip title="Puedes arrastrar al marcador para ponerlo en tu dirección exacta">
                      <InfoCircleFilled />
                    </Tooltip>
                  </span>} bordered={false} style={{ borderRadius:10}} hoverable>
                    <p><span style={{fontSize:15,color:"#2B7BBC",fontStyle:'bold'}}>Dirección</span>:{address}</p>
                    {errorAddress&&<Text type='danger'>*El campo Direccion es obligatorio</Text>}
                    <GoogleApi  coordinates={coordinates} direccion={address} setCoordinates={setCoordinates}  setAddress={setAddress}/>
                    <MapGoogle coordinates={coordinates} setCoordinates={setCoordinates}  address={address} setAddress={setAddress} />
                     
              </Card>
               </Col>
          </Row>
          <Row>
            <div style={{maxWidth:'50%',marginRight:'auto',marginLeft:'auto',marginTop:10,marginBottom:10,display:'flex',flexDirection:'column'}}  >
              {(methods.errors.nombre||methods.errors.telefono||methods.errors.empresa||methods.errors.destino||methods.errors.polIndustrial||errorAddress||errorRotacion||errorSemanaReferencia||errorTipoTurno||errorTurno)&&<Text type='danger'>*Verifique que los campos esten completos</Text>}
                <Button   onClick={methods.handleSubmit(onSubmit)} type="primary" htmlType='submit'>
                  Actualizar Información
                </Button>

            </div>
            
        
     

          </Row>
          </FormContext>
          
              
        </Fragment>
        
     );
}
 
export default UserProfile;